import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {RankedSeasonTypes} from '../../../../shared/GameEnums'
import {createOptionIn} from '../ui_utils/DomUtils'
import {UIProfileRankedController} from './UIProfileRankedController'
import {getProfilePopupElementId} from './UIViewProfilePopup'

export class UIProfileRankedSeasonDropdownController {
    seasons: AjaxDataTypes.ProfileDataRankedSeasonDropdown[]
    seasonDropdown: HTMLSelectElement
    profileRankedController: UIProfileRankedController
    isPopup: boolean

    constructor(seasons: AjaxDataTypes.ProfileDataRankedSeasonDropdown[], profileRankedController: UIProfileRankedController, isPopup: boolean = false) {
        this.isPopup = isPopup
        this.seasons = seasons
        this.seasonDropdown = this.getSeasonDropdownElement()
        this.profileRankedController = profileRankedController

        this.fetchRankedDataForLatestSeason()
        this.createDropdownOptions()
        this.createDropdownChangeEvent()
    }

    private getSeasonDropdownElement(): HTMLSelectElement {
        const id = getProfilePopupElementId('profile_ranked_season_dropdown', this.isPopup)
        return (document.getElementById(id)) as HTMLSelectElement
    }

    private fetchRankedDataForLatestSeason() {
        const latestSeason = this.seasons[0]
        this.profileRankedController.currentSeason = latestSeason.seasonType
        void this.profileRankedController.fetchRankedDataForSelectedSeason(latestSeason.seasonType)
    }

    private createDropdownOptions() {
        this.seasons.map((season: AjaxDataTypes.ProfileDataRankedSeasonDropdown) => {
            createOptionIn(this.seasonDropdown, season.seasonType.toString(), season.name)
        })
    }

    private createDropdownChangeEvent() {
        this.seasonDropdown.onchange = () => {
            const season = Number(this.seasonDropdown.value) as RankedSeasonTypes
            void this.profileRankedController.fetchRankedDataForSelectedSeason(season)
        }
    }
}
